protocolPattern